import React from 'react';
export function CampaignSurveyIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M12.707 6.707L8 11.414 5.293 8.707l1.414-1.414L8 8.586l3.293-3.293 1.414 1.414zM13 9h6V7h-6v2zm6 8h-6v-2h6v2zM8 18.414l4.707-4.707-1.414-1.414L8 15.586l-1.293-1.293-1.414 1.414L8 18.414z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1v22h22V1H1zm20 2H3v18h18V3z"
  }));
}